<script>
import appbarMixin from '@/v-shop/mixins/appbarMixin'

export default {
	mixins: [appbarMixin],
	props: {
		hideText: Boolean,
		iconColor: String,
		btnClass: String,
		iconSize: [String, Number],
		iconOptions: Object,
	},
	computed: {
		cIconOptions() {
			return this.iconOptions?.iconType
				? this.iconOptions
				: { iconType: 'default', icon: this.$g('cartIcon', 'mdi-cart') }
		},
	},
}
</script>

<template>
	<div style="position: relative">
		<v-btn
			v-if="$srv('purchaseMode') != 'single_product' && !hideCartButton"
			text
			@click="showCartDrawer"
			class="cart-btn mr-md-0 px-0 px-md-2 appbar__buttons_btn"
			:color="iconColor"
			id="show-cart-drawer-btn"
		>
			<v-badge :content="orderItemsQty" :value="!!orderItemsQty" overlap aria-label="carrito">
				<CustomIcon v-bind="cIconOptions" :icon-attrs="{ size: iconSize }" :class="!hideText && 'mr-1'" />
			</v-badge>
			<span v-if="!hideText" class="d-none d-lg-block font-1">Carrito</span>
		</v-btn>
	</div>
</template>

